import { ValueLabelResponse } from '../../types';
import { FormControl, FormLabel } from '@tq/ui-components';
import { ConsultationFilterMultiSelect } from '../ConsultationFilterMultiSelect';
import { invitePermissionState, inviteTeamsState } from '../../store';
import { ManageTeamFilterPermissionSelect } from './ManageTeamFilterPermissionSelect';
import React from 'react';
import { PageTypeProps } from './fragments/ManageTeamInviteUserProps';

type InviteAdminUserFormProps = PageTypeProps & {
  teamsLabel: string;
  items: ValueLabelResponse[] | undefined;
  disabled: boolean;
  permissionLabel: string;
};

export const InviteAdminUserForm: React.FC<InviteAdminUserFormProps> = ({
  pageType,
  teamsLabel,
  items,
  disabled,
  permissionLabel,
}) => {
  return (
    <>
      {pageType !== 'ManageTQAdmin' && (
        <>
          <FormControl width='100%'>
            <ConsultationFilterMultiSelect
              data-testid='TeamSelect'
              fieldId='teams'
              label={teamsLabel}
              items={items}
              state={inviteTeamsState}
              disabled={disabled}
            />
          </FormControl>
          <FormControl width='100%'>
            <FormLabel htmlFor='permission-invite'>{permissionLabel}:</FormLabel>
            <ManageTeamFilterPermissionSelect
              permissionState={invitePermissionState}
              includePermissionDetails
              inputId='permission-invite'
              disabled={disabled}
            />
          </FormControl>
        </>
      )}
    </>
  );
};
